import Cascader from '../../../cascader';
import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { Input } from 'antd';
import style from './index.less';

const { ListGroup } = Cascader;

// 按关键词过滤树，保留级联结构（不做平铺），这样搜索后仍是「渠道 -> 账号」的级联展示，
// 不同渠道下的同名账号也能区分。
//
// 只有叶子节点参与关键词匹配，中间节点一律只当分组标题：保留有命中子孙的节点，
// 并标记 uncheckable（不渲染 checkbox、不可点选）。这样做的原因：
// 1. 父子联动始终基于完整的 treeData 计算，勾选分组会选中该渠道下**全部**账号（含没被搜出来的），
//    与「列表里只显示了两个账号」的观感冲突，容易误选；
// 2. 若允许分组自身命中关键词，同一列里会混着「可勾选的渠道」和「纯标题的渠道」，样式和语义都不一致。
//
// search 由调用方 trim + 转小写后传入，匹配大小写不敏感（账号名常为英文 ID）。
const getSearchList = (treeData = [], search) => {
  if (!search) {
    return treeData;
  }
  const resultList = [];
  treeData.forEach(item => {
    const { label, children, title } = item;

    if (children && children.length) {
      const matchedChildren = getSearchList(children, search);
      if (matchedChildren.length) {
        resultList.push({
          ...item,
          children: matchedChildren,
          data: { ...item.data, uncheckable: true }
        });
      }
      return;
    }

    const text = (label || title || '').toString().toLowerCase();
    if (text && text.indexOf(search) > -1) {
      resultList.push({ ...item });
    }
  });
  return resultList;
};

const ListGroupSearch = forwardRef((props, ref) => {
  const { onGroupChange, groupList, metaData, multiple, showCheckedStrategy, visible, ...rest } = props;
  const [searchKey, setSearchKey] = useState('');

  // 在下拉「打开」时重置搜索词，而不是关闭时：
  // 关闭有淡出动画，此时清空关键词会让列表先闪回全量数据再消失。
  useEffect(() => {
    if (visible) setSearchKey('');
  }, [visible]);

  const searchList = useMemo(() => {
    // 只输入空格时视作未搜索，否则会一个都匹配不上、误显示「暂无数据」
    const key = searchKey.trim().toLowerCase();
    if (!key) return metaData;
    return getSearchList(metaData, key);
  }, [searchKey, metaData]);

  return (
    <div className={style.tree}>
      <Input.Search
        value={searchKey}
        onChange={e => setSearchKey(e.target.value)}
        placeholder={'搜索'}
        style={{ width: 200 }}
        className={style.search_input}
        allowClear
      />
      <ListGroup
        search={true}
        searchList={searchList}
        onChange={onGroupChange}
        value={groupList}
        treeData={metaData}
        placeholder={'请选择'}
        multiple={multiple}
        className={style['tree-check']}
        showCheckedStrategy={showCheckedStrategy}
        {...rest}
        visible={visible}
        renderNode={rest.renderNode}
      />
    </div>
  );
});

export default ListGroupSearch;
